module.exports = __webpack_public_path__ + "media/images/slide2-80303917e0d0af1e099994a900d14302.webp";